<template>
  <div class="home">
      <DirectStream class="marginal" ></DirectStream>
  </div>
</template>

<script>
import DirectStream from '@/components/DirectStream.vue';
export default {
  name: 'DirectStreamPage',
  components: {
    DirectStream
  }
}
</script>